export const categories = [
  { id: "1", name: "明星爆料", slug: "star-gossip", description: "娱乐圈明星私生活爆料、恋情曝光、婚变传闻", icon: "ri-star-line" },
  { id: "2", name: "综艺热点", slug: "variety", description: "热门综艺节目幕后故事、嘉宾矛盾、剪辑内幕", icon: "ri-tv-line" },
  { id: "3", name: "影视八卦", slug: "movie-tv", description: "影视剧拍摄内幕、演员撕番、票房争议", icon: "ri-movie-line" },
  { id: "4", name: "网红动态", slug: "influencer", description: "网红主播翻车事件、带货争议、人设崩塌", icon: "ri-live-line" },
  { id: "5", name: "圈内猛料", slug: "inside", description: "娱乐圈内部人士爆料、不为人知的行业内幕", icon: "ri-eye-line" },
  { id: "6", name: "情感纠葛", slug: "relationship", description: "明星婚恋情感、三角关系、分手复合", icon: "ri-heart-line" },
];

export const hotTags = [
  "某顶流塌房", "综艺黑幕", "CP成真", "离婚实锤", "税务风波",
  "代孕风波", "学历造假", "出轨门", "资源咖", "轧戏争议",
];

export const articles = [
  {
    id: "a1",
    title: "某顶流男星深夜密会神秘女子，狗仔跟拍三天终曝光",
    slug: "top-star-secret-meeting",
    excerpt: "据知情人士透露，这位坐拥五千万粉丝的顶流男星连续三晚现身某高档小区，与一名年轻女子举止亲密...",
    categoryId: "1",
    categoryName: "明星爆料",
    author: "吃瓜前线",
    publishDate: "2026-07-02",
    readCount: 128560,
    commentCount: 3421,
    isHot: true,
    isTop: true,
    image: "https://readdy.ai/api/search-image?query=celebrity%20paparazzi%20night%20scene%2C%20luxury%20apartment%20entrance%2C%20flash%20photography%20effect%2C%20dark%20moody%20atmosphere%2C%20street%20night%20lights%2C%20cinematic%20style%2C%20high%20contrast%2C%20warm%20tones&width=800&height=600&seq=article-a1&orientation=landscape",
    content: `<p>据知情人士透露，这位坐拥五千万粉丝的顶流男星连续三晚现身某高档小区，与一名年轻女子举止亲密。狗仔队蹲守三天，终于在昨晚拍到两人同框画面。</p>
<p>从曝光的照片来看，男子全副武装，戴着黑色鸭舌帽和口罩，但熟悉的身形还是被认出。女子身材高挑，长发披肩，看起来二十出头。两人在地下车库汇合后，一同乘坐电梯上楼。</p>
<p>更劲爆的是，据小区保安爆料，该女子已经在该住处居住了近两个月，而这套房产正是男星去年购置的"秘密基地"。</p>
<p>此事一出，粉丝圈瞬间炸锅。有网友扒出该女子的社交账号，发现 she 曾多次点赞男星的动态，两人疑似早已相识。更多猛料正在持续挖掘中，敬请关注53吃瓜网后续报道。</p>`,
    relatedIds: ["a2", "a5", "a8"],
  },
  {
    id: "a2",
    title: "当红小花旦被曝片场耍大牌，工作人员集体吐槽",
    slug: "actress-diva-on-set",
    excerpt: "多名剧组工作人员匿名爆料，某95后小花旦在最新剧组中耍大牌行为严重，甚至因不满造型当场摔东西...",
    categoryId: "1",
    categoryName: "明星爆料",
    author: "圈内老鬼",
    publishDate: "2026-07-01",
    readCount: 98720,
    commentCount: 2156,
    isHot: true,
    isTop: false,
    image: "https://readdy.ai/api/search-image?query=film%20set%20behind%20the%20scenes%2C%20angry%20actress%20moody%20atmosphere%2C%20dramatic%20lighting%2C%20dark%20color%20grading%2C%20cinematic%20photography%20style%2C%20tense%20emotion&width=800&height=600&seq=article-a2&orientation=landscape",
    content: `<p>多名剧组工作人员匿名爆料，某95后小花旦在最新剧组中耍大牌行为严重。据工作人员A透露，她因不满意当天的发型设计，当场摔了化妆镜，要求造型师重新做两个小时。</p>
<p>"她迟到是常态，最过分的一次让大家等了五个小时，来了之后还嫌灯光不对，又要重新调。"一位灯光师如是说道。</p>
<p>更离谱的是，据说她对群演态度极差，曾当众呵斥群演"挡住她的光"。有粉丝试图洗白，但剧组多个工作人员的统一口径让这件事的可信度大增。</p>`,
    relatedIds: ["a1", "a3", "a6"],
  },
  {
    id: "a3",
    title: "知名综艺导演自曝：剪辑室里的那些不可告人秘密",
    slug: "variety-editor-secrets",
    excerpt: "某S级综艺幕后导演接受采访，首度公开综艺节目剪辑内幕，包括如何制造冲突、剪辑嘉宾矛盾...",
    categoryId: "2",
    categoryName: "综艺热点",
    author: "剪辑刀",
    publishDate: "2026-06-30",
    readCount: 76540,
    commentCount: 1890,
    isHot: true,
    isTop: false,
    image: "https://readdy.ai/api/search-image?query=video%20editing%20room%2C%20multiple%20monitors%20showing%20footage%2C%20dark%20control%20room%20atmosphere%2C%20blue%20and%20orange%20monitor%20glow%2C%20professional%20post%20production%20environment%2C%20moody%20lighting&width=800&height=600&seq=article-a3&orientation=landscape",
    content: `<p>某S级综艺幕后导演化名"老王"接受采访，首度公开综艺节目剪辑内幕。据他透露，现在市面上90%的综艺冲突都是剪辑"制造"出来的。</p>
<p>"我们会把A说的某句话接到B的反应上，明明两人说的不是一回事，但剪在一起就是一场'激烈争吵'。"老王直言不讳。</p>
<p>他还透露，有些嘉宾会签"恶人合约"——故意在节目中扮演讨人嫌的角色，以此换取更高的出场费。而后期剪辑会放大他们的"恶"，制造话题度。</p>`,
    relatedIds: ["a4", "a7", "a9"],
  },
  {
    id: "a4",
    title: "暑期档票房大战内幕：某电影被恶意刷差评的真相",
    slug: "summer-box-office-war",
    excerpt: "暑期档电影竞争激烈，某大片上映首日即遭遇大量一星差评，幕后真相令人震惊...",
    categoryId: "3",
    categoryName: "影视八卦",
    author: "票房侦探",
    publishDate: "2026-06-29",
    readCount: 65430,
    commentCount: 1567,
    isHot: false,
    isTop: false,
    image: "https://readdy.ai/api/search-image?query=movie%20theater%20empty%20seats%2C%20cinematic%20wide%20shot%2C%20red%20velvet%20seats%2C%20screen%20glowing%20in%20darkness%2C%20dramatic%20perspective%2C%20warm%20and%20cool%20contrast%20lighting&width=800&height=600&seq=article-a4&orientation=landscape",
    content: `<p>暑期档电影竞争激烈，某大片上映首日即遭遇大量一星差评。经调查发现，这些差评账号多为新注册小号，且评论内容高度雷同，疑似有组织的恶意刷评行为。</p>
<p>据业内人士透露，这已经是电影圈的"常规操作"。每逢热门档期，竞争对手雇佣水军互相攻击已成潜规则。一部电影的口碑，往往从上映前一周就开始被"操盘"。</p>`,
    relatedIds: ["a2", "a5", "a10"],
  },
  {
    id: "a5",
    title: "网红主播带货翻车，直播间承诺与实际发货完全不符",
    slug: "influencer-livestream-scam",
    excerpt: "拥有千万粉丝的带货主播被曝虚假宣传，消费者收到的商品与直播间展示严重不符，维权群已超千人...",
    categoryId: "4",
    categoryName: "网红动态",
    author: "维权先锋",
    publishDate: "2026-06-28",
    readCount: 112300,
    commentCount: 4521,
    isHot: true,
    isTop: false,
    image: "https://readdy.ai/api/search-image?query=livestream%20studio%20setup%2C%20ring%20lights%20and%20cameras%2C%20product%20display%20table%2C%20bright%20colorful%20but%20slightly%20chaotic%20atmosphere%2C%20social%20media%20content%20creation%20space%2C%20warm%20tones&width=800&height=600&seq=article-a5&orientation=landscape",
    content: `<p>拥有千万粉丝的带货主播"XX姐"被曝虚假宣传。消费者在直播间看到的商品与收到的实物天差地别——直播间展示的"真丝连衣裙"实际为聚酯纤维，所谓"进口燕窝"实为糖水。</p>
<p>目前维权群已经超过千人，多名消费者表示申请退款被驳回，客服态度恶劣。而主播方目前暂未对此事做出回应。</p>`,
    relatedIds: ["a1", "a6", "a8"],
  },
  {
    id: "a6",
    title: "资深经纪人爆料：明星人设崩塌背后的真相",
    slug: "agent-reveals-star-persona",
    excerpt: "从业十五年的资深经纪人接受采访，揭露娱乐圈人设打造产业链，以及那些看似完美人设背后的不堪...",
    categoryId: "5",
    categoryName: "圈内猛料",
    author: "幕后推手",
    publishDate: "2026-06-27",
    readCount: 89340,
    commentCount: 2345,
    isHot: false,
    isTop: false,
    image: "https://readdy.ai/api/search-image?query=backstage%20dressing%20room%2C%20vanity%20mirror%20with%20bulb%20lights%2C%20makeup%20products%20scattered%2C%20moody%20dramatic%20lighting%2C%20dark%20luxury%20interior%2C%20cinematic%20style%2C%20warm%20amber%20tones&width=800&height=600&seq=article-a6&orientation=landscape",
    content: `<p>从业十五年的资深经纪人化名"阿杰"接受采访，揭露娱乐圈人设打造产业链。他表示，现在市场上80%的明星人设都是团队精心设计的"产品"。</p>
<p>"学霸人设是最危险的，因为随时可能被扒出学历造假。深情专一男的人设也崩了不少，但凡被拍到一次就会全盘皆输。"阿杰如是说。</p>
<p>他还透露，团队会专门雇人"盯梢"对家，一旦发现对方人设漏洞，立刻安排营销号集体出动，争取一波带走。</p>`,
    relatedIds: ["a2", "a7", "a9"],
  },
  {
    id: "a7",
    title: "昔日模范夫妻官宣离婚，财产分割内幕曝光",
    slug: "model-couple-divorce",
    excerpt: "结婚十年的娱乐圈模范夫妻突然宣布离婚，背后财产分割方案引发热议，双方律师团队已正面交锋...",
    categoryId: "6",
    categoryName: "情感纠葛",
    author: "情感猎手",
    publishDate: "2026-06-26",
    readCount: 145600,
    commentCount: 5623,
    isHot: true,
    isTop: true,
    image: "https://readdy.ai/api/search-image?query=wedding%20rings%20broken%20apart%2C%20dramatic%20macro%20photography%2C%20shattered%20glass%20effect%2C%20dark%20moody%20background%2C%20emotional%20contrast%20lighting%2C%20cinematic%20style%2C%20warm%20and%20cold%20tones&width=800&height=600&seq=article-a7&orientation=landscape",
    content: `<p>结婚十年的娱乐圈模范夫妻突然宣布离婚，震惊全网。双方工作室同时发布声明，表示"和平分手，各自安好"，但知情人士透露，财产分割方案已经谈了近半年。</p>
<p>据悉，两人共同拥有多处房产、投资公司股权以及代言合约，总价值超过十亿。目前双方律师团队正在就某些海外资产的归属权进行激烈交锋。</p>
<p>更值得关注的是，两人之前代言的"恩爱夫妻"形象品牌方已经开始追究违约责任。据估算，违约金可能高达数千万。</p>`,
    relatedIds: ["a1", "a8", "a10"],
  },
  {
    id: "a8",
    title: "选秀节目内幕：投票数据竟然可以人为操控",
    slug: "talent-show-vote-rigging",
    excerpt: "某选秀节目后台技术人员匿名爆料，观众投票系统存在漏洞，排名可以被后台直接修改...",
    categoryId: "2",
    categoryName: "综艺热点",
    author: "技术揭秘",
    publishDate: "2026-06-25",
    readCount: 72300,
    commentCount: 1890,
    isHot: false,
    isTop: false,
    image: "https://readdy.ai/api/search-image?query=talent%20show%20stage%20lights%2C%20dramatic%20spotlight%20beams%2C%20voting%20scoreboard%20numbers%20glowing%2C%20dark%20concert%20atmosphere%2C%20laser%20lights%20and%20smoke%2C%20cinematic%20style&width=800&height=600&seq=article-a8&orientation=landscape",
    content: `<p>某选秀节目后台技术人员匿名爆料，观众投票系统存在严重漏洞。据他透露，所谓的"实时票数"实际上在后台可以随意修改。</p>
<p>"我们有个管理员面板，可以直接调整每个选手的得票数。有时候领导一句话，某个选手的排名就上去了。"该技术人员表示。</p>
<p>他还透露，真正的观众投票只占最终排名的30%，剩下的70%由节目组和赞助方决定。这意味着，所谓"全民pick"只是一场精心设计的表演。</p>`,
    relatedIds: ["a3", "a5", "a9"],
  },
  {
    id: "a9",
    title: "某实力派演员被曝税务问题，金额高达数千万",
    slug: "actor-tax-scandal",
    excerpt: "税务部门日前对某实力派男演员展开调查，涉嫌通过阴阳合同和离岸公司逃避税款，金额惊人...",
    categoryId: "1",
    categoryName: "明星爆料",
    author: "财经眼",
    publishDate: "2026-06-24",
    readCount: 156700,
    commentCount: 6789,
    isHot: true,
    isTop: true,
    image: "https://readdy.ai/api/search-image?query=government%20building%20entrance%2C%20serious%20official%20atmosphere%2C%20dark%20stormy%20clouds%20above%2C%20dramatic%20lighting%2C%20document%20papers%20scattered%20effect%2C%20cinematic%20style%2C%20cool%20tones&width=800&height=600&seq=article-a9&orientation=landscape",
    content: `<p>税务部门日前对某实力派男演员展开调查，涉嫌通过阴阳合同和离岸公司逃避税款。据初步估算，涉及金额高达数千万。</p>
<p>据悉，该演员通过在香港注册的皮包公司收取片酬，再以"咨询服务费"的名义回流到个人账户，以此规避高额个人所得税。</p>
<p>目前已有多个品牌方宣布暂停与其合作。如果税务问题坐实，他可能面临补缴税款、滞纳金以及罚款，总金额可能过亿。</p>`,
    relatedIds: ["a2", "a6", "a10"],
  },
  {
    id: "a10",
    title: "新人演员靠关系上位？某剧组选角内幕遭曝光",
    slug: "newcomer-nepotism-casting",
    excerpt: "某大制作剧组选角被曝存在暗箱操作，新人女一号与制片方关系匪浅，其他试镜演员纷纷出局...",
    categoryId: "3",
    categoryName: "影视八卦",
    author: "选角雷达",
    publishDate: "2026-06-23",
    readCount: 54300,
    commentCount: 1234,
    isHot: false,
    isTop: false,
    image: "https://readdy.ai/api/search-image?query=casting%20audition%20room%2C%20actress%20standing%20under%20spotlight%2C%20dark%20theater%20atmosphere%2C%20judges%20table%20silhouette%2C%20dramatic%20single%20light%20beam%2C%20warm%20amber%20tones%2C%20cinematic%20style&width=800&height=600&seq=article-a10&orientation=landscape",
    content: `<p>某S+大制作剧组选角被曝存在暗箱操作。原定经过三轮公开试镜选出的女主角，在开拍前一周突然被替换。</p>
<p>新上位的新人演员背景引发网友深扒。据悉，她与该片制片人存在私人关系，其父更是某上市公司的实际控制人。有参与试镜的演员表示"早就知道结果会被内定"。</p>
<p>不过该剧投资方回应称选角完全基于"艺术考量"，否认任何暗箱操作。但网友的质疑声浪仍在持续发酵。</p>`,
    relatedIds: ["a4", "a7", "a9"],
  },
];

export const comments = [
  { id: "c1", articleId: "a1", author: "瓜田守望者", avatar: "", content: "这瓜保熟吗？三天蹲守也太敬业了吧", date: "2026-07-02", likes: 234 },
  { id: "c2", articleId: "a1", author: "理性吃瓜", avatar: "", content: "等一个反转，现在的狗仔图十个有九个是P的", date: "2026-07-02", likes: 189 },
  { id: "c3", articleId: "a2", author: "剧组打工人", avatar: "", content: "业内人士说一句，这种事在剧组太常见了，只是没人敢爆", date: "2026-07-01", likes: 456 },
  { id: "c4", articleId: "a3", author: "剪辑师本师", avatar: "", content: "老王说得保守了，实际情况比他说得更夸张", date: "2026-06-30", likes: 321 },
  { id: "c5", articleId: "a7", author: "婚姻咨询师", avatar: "", content: "十年婚姻说散就散，娱乐圈的爱情我真的不懂", date: "2026-06-26", likes: 567 },
  { id: "c6", articleId: "a9", author: "税务师小李", avatar: "", content: "阴阳合同这个操作太经典了，抓一个准一个", date: "2026-06-24", likes: 789 },
];

export const hotArticles = articles.filter(a => a.isHot).slice(0, 6);
export const topArticles = articles.filter(a => a.isTop).slice(0, 3);
export const latestArticles = [...articles].sort((a, b) => b.publishDate.localeCompare(a.publishDate)).slice(0, 6);